import { render, staticRenderFns } from "./BetListModal.vue?vue&type=template&id=60b29fea&scoped=true"
import script from "./BetListModal.vue?vue&type=script&lang=ts"
export * from "./BetListModal.vue?vue&type=script&lang=ts"
import style0 from "./BetListModal.vue?vue&type=style&index=0&id=60b29fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b29fea",
  null
  
)

export default component.exports